import * as React from "react"
import { connect } from "react-redux"
import { IMeta } from "../../reducers/metaReducer"
import * as metaReducer from "../../reducers/metaReducer"
import { ToastContainer, toast } from "react-toastify"
import i18n from "../../i18n/i18n"
import * as classNames from "classnames"

export interface IToastrMessage {
    message: string,
    type: "error" | "info" | "success" | "warning"
}

interface IToastrContainerProps {
    messages?: IToastrMessage[],
}

interface IToastrContainerDispatch {
    onRemoveToastr?: (message: IToastrMessage) => void
}

type AllProps = IToastrContainerProps & IToastrContainerDispatch

class Toastr extends React.Component<AllProps> {
    constructor(props: IToastrContainerProps) {
        super(props)
    }

    public UNSAFE_componentWillReceiveProps(nextProps: IToastrContainerProps) {
        if (nextProps.messages) {
            nextProps.messages.forEach(toastrMessage => {
                const classes = classNames(
                    {
                        "toastify-content": true,
                        "toastify-content--success": toastrMessage.type === "success",
                        "toastify-content--error": toastrMessage.type === "error",
                        "toastify-content--info": toastrMessage.type === "info",
                        "toastify-content--warning": toastrMessage.type === "warning",
                    })

                const options = {
                    type: toastrMessage.type,
                    className: classes
                }

                const message = toastrMessage.message ?
                    i18n.t(toastrMessage.message) :
                    i18n.t("VALIDATION_UNKNOWN_ERROR")

                toast(message, options)

                this.props.onRemoveToastr(toastrMessage)
            })
        }
    }

    public render() {
        return (
            <ToastContainer
                position="bottom-center"
                autoClose={7000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
            />
        )
    }
}
const mapStateToProps = (state: { meta: IMeta }): IToastrContainerProps => {
    const messages = state.meta.toastrMessages
    return {
        messages
    }
}

const mapDispatchToProps = (dispatch: any): IToastrContainerDispatch => {
    return {
        onRemoveToastr: (toastrMessage: IToastrMessage) => {
            dispatch(metaReducer.removeToastr(toastrMessage))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Toastr)